import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { MFAVerification } from '@/components/auth/MFAVerification';

interface AuthGuardProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ 
  children, 
  requireAuth = true 
}) => {
  const { user, loading, needsMFA, clearMFARequirement } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (requireAuth && !user) {
    return <Navigate to="/auth" replace />;
  }

  // If user is authenticated but needs MFA verification
  if (user && needsMFA) {
    return (
      <MFAVerification
        onSuccess={() => {
          clearMFARequirement();
        }}
        onCancel={() => {
          clearMFARequirement();
        }}
      />
    );
  }

  if (!requireAuth && user && !needsMFA) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};